import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/main.sass';
import './utils/i18n/i18n';
import App from './app/app';
import Widget from './widget/widget';

const rootElement = document.getElementById('whatcrm-root');
const widgetElement = document.getElementById('whatcrm-widget');

if (widgetElement) {
  const whatcrmWidget = ReactDOM.createRoot(widgetElement);
  whatcrmWidget.render(<Widget />);
} else if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
